import { render, staticRenderFns } from "./DoubleSideTriangleVertical.vue?vue&type=template&id=8d311db8&scoped=true&"
import script from "./DoubleSideTriangleVertical.vue?vue&type=script&lang=js&"
export * from "./DoubleSideTriangleVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d311db8",
  null
  
)

export default component.exports